import React, { Component } from 'react';
import { LocalizationProvider, DatePicker as MuiDatePicker, DateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { Box, Grid, TextField } from '@mui/material';

class DatePicker extends Component {
  state = {};

  render() {
    const { label, value, minDate } = this.props;
    return (
      <Box p={1}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Grid container justifyContent="space-around">
            <MuiDatePicker
              minDate={minDate}
              invalidDateMessage="Date Invalide"
              style={{ width: "100%" }}
              id="date-picker-dialog"
              format="dd/MM/yyyy"
              label={label}
              value={value}
              inputVariant="outlined"
              onChange={this.props.onChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  error={!!this.props.error}
                  helperText={this.props.error}
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          </Grid>
        </LocalizationProvider>
      </Box>
    );
  }
}

export default DatePicker;

export class DateTimePicker extends Component {
  state = {};

  render() {
    const { label, value, minDate } = this.props;
    return (
      <Box p={1}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Grid container justifyContent="space-around">
            <MuiDateTimePicker
              minDate={minDate}
              invalidDateMessage="Date Invalide"
              style={{ width: "100%" }}
              id="date-picker-dialog"
              format="dd/MM/yyyy hh:mm a"
              label={label}
              value={value}
              inputVariant="outlined"
              onChange={this.props.onChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  error={!!this.props.error}
                  helperText={this.props.error}
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          </Grid>
        </LocalizationProvider>
      </Box>
    );
  }
}
